export enum GIFT_REGISTRY_SDK_METHODS {
    OPEN_GIFT_REGISTRY_FORM_MODAL = "openGiftRegistryFormModal",
}
